import React from "react";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";

const MultiSelectField = ({
  label,
  name,
  options,
  formik,
  MenuProps,
}) => {
  return (
    <FormControl
      fullWidth
      error={formik.touched[name] && Boolean(formik.errors[name])}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>

      <Select
        labelId={`${name}-label`}
        multiple
        name={name}
        value={formik.values[name] || []}
        onChange={formik.handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip
                key={value}
                label={options.find((opt) => opt.value === value)?.label || value}
                onDelete={() => {
                  formik.setFieldValue(
                    name,
                    formik.values[name].filter((id) => id !== value)
                  );
                }}
                onMouseDown={(event) => event.stopPropagation()}
              />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>

      {formik.touched[name] && formik.errors[name] && (
        <Typography color="error" variant="caption">
          {formik.errors[name]}
        </Typography>
      )}
    </FormControl>
  );
};

export default MultiSelectField;
